import React, { useState, useEffect } from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import { ScoreStats } from '../components'
import { useStore } from '../lib'
// import logoUhul from "../assets/base/logo_uhul.jpg";
import logoUhul from '../assets/base/logo_uhul2.jpg'
import logoLP from '../assets/base/logo_lesni_pedagogika.jpg'
import logoIYF from '../assets/base/IYF_Logo_Czech.png'

export const Credits = () => {
  const { state, patchState } = useStore()
  const history = useHistory()

  useEffect(() => {
    // setTimeout(() => window.print(), 300)
  }, [])

  return (
    <div className="view">
      <div className="p-5 text-black view-content background-summer">
        <div className="card glass w-full p-5 overflow-y-auto">
          <h1 className="text-3xl font-bold">Lesníkův učeň</h1>
          <div className="flex flex-wrap mt-5">
            <div className="w-full md:w-2/6 mt-5">
              <div>
                <p className="text-left font-bold mb-2">Námět a příprava hry</p>
                <p className="text-left">Ing. Lada Matoušková Prylová</p>
                <p className="text-left">Ing. Zuzana Kajfoszová</p>
                <p className="text-left">Eva Dynybylová, DiS.</p>
                <p className="text-left">Ing. Michaela Prokopová</p>
                <p className="text-left">Ing. Štěpánka Jouzová</p>
              </div>
              <div>
                <p className="text-left font-bold mb-2 mt-5">Grafické zpracování</p>
                <p className="text-left">BcA. Veronika Chlumská</p>
              </div>
              <div className="mt-10">
                <p className="text-left font-bold mb-2">Fotografie a materiály laskavě poskytly</p>
                <p className="text-left">
                  <a href="//cesles.cz">Česká lesnická společnost</a>
                </p>
                <p className="text-left">
                  <a href="//mezistromy.cz">internetový portál www.mezistromy.cz</a>
                </p>
                <p className="text-left">
                  <a href="//kr-vysocina.cz">Krajský úřad kraje Vysočina</a>
                </p>
                <p className="text-left">
                  <a href="https://lzboubin.lesycr.cz/vyznamne-objekty/lesni-skolka-budkov/">Lesní školka Budkov</a>
                </p>
                <p className="text-left">
                  <a href="//lesoskolky.cz/">Lesoškolky Řečany nad Labem</a>
                </p>
                <p className="text-left">
                  <a href="//lesycr.cz/">Lesy České republiky</a>
                </p>
                <p className="text-left">
                  <a href="//lhmp.cz/">Lesy hl. m. Prahy</a>
                </p>
                <p className="text-left">
                  <a href="//slshranice.cz/">Střední lesnická škola v Hranicích</a>
                </p>
                <p className="text-left">
                  <a href="//cmmj.cz/">Českomoravská myslivecká jednota</a>
                </p>
                <p className="text-left">
                  <a href="//web.nlcsk.org/">Národné lesnické centrum</a>
                </p>
              </div>
            </div>
            {/*<div className="w-full md:w-1/4 mt-5">*/}
            {/*  <p className="text-left font-bold mb-2">*/}
            {/*    Fotografie a materiály laskavě poskytly*/}
            {/*  </p>*/}
            {/*  <p className="text-left">*/}
            {/*    <a href="//cesles.cz">Česká lesnická společnost</a>*/}
            {/*  </p>*/}
            {/*  <p className="text-left">*/}
            {/*    <a href="//mezistromy.cz">internetový portál www.mezistromy.cz</a>*/}
            {/*  </p>*/}
            {/*  <p className="text-left">*/}
            {/*    <a href="//kr-vysocina.cz">Krajský úřad kraje Vysočina</a>*/}
            {/*  </p>*/}
            {/*  <p className="text-left">*/}
            {/*    <a href="https://lzboubin.lesycr.cz/vyznamne-objekty/lesni-skolka-budkov/">Lesní školka Budkov</a>*/}
            {/*  </p>*/}
            {/*  <p className="text-left">*/}
            {/*    <a href="//lesoskolky.cz/">Lesoškolky Řečany nad Labem</a>*/}
            {/*  </p>*/}
            {/*  <p className="text-left">*/}
            {/*    <a href="//lesycr.cz/">Lesy České republiky</a>*/}
            {/*  </p>*/}
            {/*  <p className="text-left">*/}
            {/*    <a href="//lhmp.cz/">Lesy hl. m. Prahy</a>*/}
            {/*  </p>*/}
            {/*  <p className="text-left">*/}
            {/*    <a href="//slshranice.cz/">Střední lesnická škola v Hranicích</a>*/}
            {/*  </p>*/}
            {/*  <p className="text-left">*/}
            {/*    <a href="//cmmj.cz/">Českomoravská myslivecká jednota</a>*/}
            {/*  </p>*/}
            {/*  <p className="text-left">*/}
            {/*    <a href="//web.nlcsk.org/">Národné lesnické centrum</a>*/}
            {/*  </p>*/}
            {/*</div>*/}
            <div className="w-full md:w-1/4 mt-5">
              <p className="text-left font-bold mb-2">Autoři fotografií a obrázků</p>
              <p className="text-left">Tomáš Francálek</p>
              <p className="text-left">Jiří Junek</p>
              <p className="text-left">Petra Kulhanová</p>
              <p className="text-left">Stanislava Postlová</p>
              <p className="text-left">Stanislava Šejblová</p>
              <p className="text-left">Zuzana Kajfoszová</p>
              <p className="text-left">Hynek Popelář</p>
              <p className="text-left">Štěpán Březovják</p>
              <p className="text-left">Richard Slabý</p>
              <p className="text-left"></p>
              <p className="text-left">
                <a href="https://creativecommons.org/licenses/by-sa/3.0/deed.cs">Tim Peukert</a>
              </p>
              <p className="text-left">
                <a href="//birdphoto.cz">Tomáš Pospíšil</a>
              </p>
              <p className="text-left">
                <a href="//birdphoto.cz">Petr Šaj</a>
              </p>
              <p className="text-left">Miloslav Kratochvíl</p>
              <p className="text-left">Jiří Kasina</p>
              <p className="text-left">
                <a href="//hlavica.cz">Robert Hlavica</a>
              </p>
              <p className="text-left">
                <a href="//worldnaturephoto.com">Jaroslav Vogeltanz</a>
              </p>
              <p className="text-left">
                <a href="//www.jiriliscak.cz/">Jiří Liščák</a>
              </p>
              <p className="text-left">
                <a href="https://www.foto-priban.cz/">Václav Přibáň</a>
              </p>
              <p className="text-left">Michael Migos</p>
              <p className="text-left">
                <a href="//www.royalnature.cz/">Tomáš Vlasák</a>
              </p>
              <p className="text-left">Štěpánka Jouzová</p>
            </div>
            <div className="w-full md:w-1/4 mt-5">
              <div>
                <p className="text-left font-bold mb-2">Stopy</p>
                <p className="text-left">Radomil Žatka</p>
                <p className="text-left">Zdeňka Zítová</p>
              </div>
              <div className="mt-10">
                <p className="text-left font-bold mb-2">Zvuky</p>
                <p className="text-left">Pavel Pelz</p>
                <p className="text-left">J. Hanzák</p>
                <p className="text-left">J. C. Roché</p>
                <p className="text-left">O. Mihály</p>
              </div>
              <div className="mt-10">
                <p className="text-left font-bold mb-2">Fanfára</p>
                <p className="text-left">Radek Kajfosz</p>
              </div>
            </div>
            <div className="w-full md:w-1/6 mt-5">
              <img src={logoUhul} alt="" className="image-full w-3/4 float-right rounded-xl" />
              <img src={logoLP} alt="" className="image-full w-3/4 float-right mt-5 rounded-xl" />
              {/*<img src={logoIYF} alt="" className="image-full w-3/4 float-right mt-5 rounded-xl" />*/}
            </div>
            {/*<div className="w-full md:w-1/4 mt-5">*/}
            {/*  <p className="text-left font-bold mb-2">*/}
            {/*    Stopy*/}
            {/*  </p>*/}
            {/*  <p className="text-left">*/}
            {/*    Radomil Žatka*/}
            {/*  </p>*/}
            {/*  <p className="text-left">*/}
            {/*    Zdeňka Zítová*/}
            {/*  </p>*/}
            {/*</div>*/}
            {/*<div className="w-full md:w-1/3 mt-5">*/}
            {/*  <p className="text-left font-bold mb-2">*/}
            {/*    Fanfára*/}
            {/*  </p>*/}
            {/*  <p className="text-left">*/}
            {/*    Radek Kajfosz*/}
            {/*  </p>*/}
            {/*</div>*/}
            <div className="w-full mt-5 flex items-center justify-center">
              <div>
                <p className="text-center text-xl font-bold mb-2">Děkujeme.</p>
                <p className="text-center">
                  Hru Lesníkův učeň vytvořil Ústav pro hospodářskou úpravu lesů Brandýs nad Labem 2021
                  <br />
                  <a href="//uhul.cz">www.uhul.cz Informace o lesích</a>
                </p>
                <br />
                <p className="text-center">
                  Vyrobil <a href="//tomasberan.net">Tomáš Beran</a> 2021
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="fixed z-10 bottom-0 left-5">
          <button className="text-xl text-black btn btn-block mb-5 glass" onClick={() => history.goBack()}>
            zpět
          </button>
        </div>
      </div>
    </div>
  )
}
